;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import countryPlaceholderAddresses from './country-placeholder-addresses.json';

export interface CountryAddressPlaceholder {
  address: string;
  city: string;
}

const FALLBACK_PLACEHOLDER = 'Type here';

const placeholders = countryPlaceholderAddresses as Record<string, CountryAddressPlaceholder>;

export function getCountryAddressPlaceholders(isoCode: string): CountryAddressPlaceholder {
  const match = isoCode ? placeholders[isoCode.toUpperCase()] : undefined;

  return {
    address: match?.address || FALLBACK_PLACEHOLDER,
    city: match?.city || FALLBACK_PLACEHOLDER,
  };
}
